import React from 'react'
import request from 'superagent'
import R from 'ramda'
import PropTypes from 'prop-types'

import AutoCompleteBasis from './index'
import {
  isNilOrEmpty
} from '_utils'

function debounce (fn, delay) {
  let timer = null
  return function () {
    const context = this
    const args = arguments
    clearTimeout(timer)
    timer = setTimeout(function () {
      fn.apply(context, args)
    }, delay)
  }
}

export default class AutoComplete extends React.PureComponent {
  xhr = null
  state = {
    total: 0,
    pageNum: 1,
    selections: this.props.selections || [],
    suggestions: [],
    isLoading: false
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    this.setState({selections: nextProps.selections})
  }

  mapHttpBodyToSuggestions = R.prop('results')

  onSelectionChange = (selections, sel) => {
    this.setState({selections}, () => this.props.onSelectionChange(selections, sel))
  }

  onClearSuggestions = () => this.setState({suggestions: [], total: 0, pageNum: 1})

  onTermChange = debounce(({term, pageNum}) => {
    if (this.xhr) {
      this.xhr.abort()
    }
    const mapHttpBodyToSuggestions = this.props.mapHttpBodyToSuggestions || this.mapHttpBodyToSuggestions
    if (isNilOrEmpty(term)) return
    this.setState({isLoading: true})
    const url = this.props.getUrl(term)
    this.xhr = request.get(url)
      .withCredentials()
      .set('Content-Type', 'application/json')
      .accept('json')
      .query({term, pageNum})
      .end((err, res) => {
        if (err || R.has('error', R.prop('body', res))) {
          const errMsg = R.path(['body', 'error'], res) || R.path(['response', 'body', 'error'], err) || err
          this.setState({isLoading: false})
          window.alert(errMsg)
        } else {
          // don't filter any responses
          const suggestions = mapHttpBodyToSuggestions(res.body)
          this.setState({suggestions, isLoading: false, total: res.body.total, pageNum: res.body.pageNum})
        }
      })
  }, 500)

  render () {
    return (
      <AutoCompleteBasis
        zIndex={this.props.zIndex}
        icon={this.props.icon || null}
        uniqField={this.props.uniqField}
        total= {this.state.total || 0}
        pageNum= {this.state.pageNum || 1}
        placeholder= {this.props.placeholder }

        isLoading={this.state.isLoading}
        onTermChange={this.onTermChange}
        onSelectionChange={this.onSelectionChange}
        onClearSuggestions={this.onClearSuggestions}

        selections = { this.state.selections }
        suggestions = { this.state.suggestions }

        formatSelection={ this.props.formatSelection }
        formatSuggestion={ this.props.formatSuggestion }
      />
    )
  }
}

AutoComplete.propTypes = {
  zIndex: PropTypes.number,
  icon: PropTypes.string,
  uniqField: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  selections: PropTypes.array,
  onSelectionChange: PropTypes.func,
  formatSelection: PropTypes.func.isRequired,
  formatSuggestion: PropTypes.func.isRequired,
  getUrl: PropTypes.func,
  mapHttpBodyToSuggestions: PropTypes.func
}



// WEBPACK FOOTER //
// ./webAdmin/views/autocomplete/url.js